import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { Grid, Typography } from '@mui/material';
import SimpleCard from '../../../../../components/SimpleCard';

const DefaultIcon = L.icon({
  iconUrl: '/marker_1.gif',
  shadowUrl: iconShadow,
  iconSize: [30, 41],
});

const DEFAULT_LAT_LONG = [38, -97];

export default function Map({ city }) {
  const hasFlewToLocation = useRef(false);

  function FlyMapTo() {
    const map = useMap();

    useEffect(() => {
      if (hasFlewToLocation.current) return;
      if (!city?.latitude || !city?.longitude) {
        map.setView(DEFAULT_LAT_LONG, 100);
        return;
      }

      const latLong = [city?.latitude, city?.longitude];
      map.setView(latLong, 13);
      hasFlewToLocation.current = true;
    }, [city, map]);

    return null;
  }

  return (
    <Grid container>
      <Grid item xs={12} md={2}>
        <Typography variant="h6" fontWeight="bold">
          Venue location:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <SimpleCard>
          <MapContainer
            style={{ width: '100%', height: '400px' }}
            zoomControl={false}
            center={[0, 0]}
            zoom={12}>
            <FlyMapTo />
            <TileLayer
              checked
              attribution='&copy; <a href="http://osm.org/copyright">Google</a> contributors'
              url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
            />
            <Marker
              icon={DefaultIcon}
              position={city ? [city?.latitude, city?.longitude] : DEFAULT_LAT_LONG}
            />
          </MapContainer>
        </SimpleCard>
      </Grid>
    </Grid>
  );
}

Map.propTypes = {
  city: PropTypes.instanceOf(Object).isRequired,
};
